export const images = {
  i4973: {
    name: "4973",
    desc: "Conical Paper Bags for fresh herbs, lettuce, etc.",
    imageTiny: require("../assets/images/tiny/4973.jpg"),
    imageSmall: require("../assets/images/small/4973.jpg"),
  },
  i5093: {
    name: "5093",
    desc: "Paper Bag with v-neck cut-out",
    imageTiny: require("../assets/images/tiny/5093.jpg"),
    imageSmall: require("../assets/images/small/5093.jpg"),
  },
  i5043: {
    name: "5043",
    desc: "Paper & Plastic Sleeves",
    imageTiny: require("../assets/images/tiny/5043.jpg"),
    imageSmall: require("../assets/images/small/5043.jpg"),
  },
  i4969: {
    name: "4969",
    desc: "Conical Paper Bags",
    imageTiny: require("../assets/images/tiny/4969.jpg"),
    imageSmall: require("../assets/images/small/4969.jpg"),
  },
  i4991: {
    name: "4991",
    desc: "FlowPack",
    imageTiny: require("../assets/images/tiny/4991.jpg"),
    imageSmall: require("../assets/images/small/4991.jpg"),
  },
  i4976: {
    name: "4976",
    desc: "FlowPack Bags for fresh vegetables, salades, ..",
    imageTiny: require("../assets/images/tiny/4976.jpg"),
    imageSmall: require("../assets/images/small/4976.jpg"),
  },
  i5072: {
    name: "5072",
    desc: "Corrugated - Duplex Cardboard Trays for Dairy",
    imageTiny: require("../assets/images/tiny/5072.jpg"),
    imageSmall: require("../assets/images/small/5072.jpg"),
  },
  i5032: {
    name: "5032",
    desc: "Conical Candy Bags",
    imageTiny: require("../assets/images/tiny/5032.jpg"),
    imageSmall: require("../assets/images/small/5032.jpg"),
  },
  i5038: {
    name: "5038",
    desc: "Wrapping Foils",
    imageTiny: require("../assets/images/tiny/5038.jpg"),
    imageSmall: require("../assets/images/small/5038.jpg"),
  },
  i5063: {
    name: "5063",
    desc: "TopSeal",
    imageTiny: require("../assets/images/tiny/5063.jpg"),
    imageSmall: require("../assets/images/small/5063.jpg"),
  },
  i5004: {
    name: "5004",
    desc: "Conical Bag for lettuce",
    imageTiny: require("../assets/images/tiny/5004.jpg"),
    imageSmall: require("../assets/images/small/5004.jpg"),
  },
  i5057: {
    name: "5057",
    desc: "Corrugated Cardboard with design and plastic window",
    imageTiny: require("../assets/images/tiny/5057.jpg"),
    imageSmall: require("../assets/images/small/5057.jpg"),
  },
  i5109: {
    name: "5109",
    desc: "Solid Cardboard trays",
    imageTiny: require("../assets/images/tiny/5109.jpg"),
    imageSmall: require("../assets/images/small/5109.jpg"),
  },
  i5090: {
    name: "5090",
    desc: "Assortment of cardboard boxes and trays",
    imageTiny: require("../assets/images/tiny/5090.jpg"),
    imageSmall: require("../assets/images/small/5090.jpg"),
  },
  i4995: {
    name: "4995",
    desc: "Duplex Inliners",
    imageTiny: require("../assets/images/tiny/4995.jpg"),
    imageSmall: require("../assets/images/small/4995.jpg"),
  },
  i5085: {
    name: "5085",
    desc: "Plastic Box Covers",
    imageTiny: require("../assets/images/tiny/5085.jpg"),
    imageSmall: require("../assets/images/small/5085.jpg"),
  },
};
